import { GET } from "../constants/request-type";
import { admin, get_all_admin } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "./axios";

const tokenExpired = async () => {
  if (
    !sessionStorage.getItem("auth_token") ||
    sessionStorage.getItem("auth_token") === undefined
  )
    sessionStorage.clear();

  const request_details = {
    type: GET,
    url: service_api,
    route: admin + "/" + get_all_admin,
    data: null,
    token: sessionStorage.getItem("auth_token")
  };
  try {
    await MakeRequestAsync(request_details);
    // Token is valid
  } catch (err) {
    sessionStorage.clear();
    return (window.location.href = "/");
  }
};

export { tokenExpired };
